import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const ProductCard = ({ product, index = 0 }) => (
  <Reveal delay={index * 0.08} className="h-full">
    <Link
      to={product.path}
      data-testid={`product-card-${product.id}`}
      className="group card-line flex h-full flex-col p-7 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-blue-500/60 hover:shadow-xl hover:shadow-blue-600/10"
    >
      <div className="flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
          {String(index + 1).padStart(2, "0")}
        </span>
        <ArrowUpRight
          size={18}
          className="text-slate-300 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-blue-600"
          aria-hidden="true"
        />
      </div>
      <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-slate-900">
        {product.name}
      </h3>
      <p className="mt-1 text-xs font-semibold uppercase tracking-[0.14em] text-blue-700">
        {product.category}
      </p>
      <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">
        {product.shortDescription}
      </p>
      <div className="mt-6 flex flex-wrap gap-1.5">
        {product.capabilityGroups[0].items.slice(0, 3).map((c) => (
          <span key={c} className="rounded-full bg-slate-100 px-2.5 py-1 text-[11px] text-slate-600">
            {c}
          </span>
        ))}
      </div>
    </Link>
  </Reveal>
);
